module.exports = __webpack_public_path__ + "img/lumilive_6.e4b631b2.png";